import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { NoBusinessManager, NoBusinessManagerForm } from "./noBusinessManagerDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<NoBusinessManager>,
  data?: NoBusinessManager,
): NoBusinessManagerForm {
  return new NoBusinessManagerForm(context, data);
}

export function handleEvent() {}

export function isValid(form: NoBusinessManagerForm): boolean {
  return (
    form.previousBusinessManager !== undefined || form.data?.previousBusinessManager !== undefined
  );
}

export function validate(form: NoBusinessManagerForm): boolean {
  return isValid(form);
}

export function applyForm(form: NoBusinessManagerForm): NoBusinessManager {
  const snapshot = form.data?.previousBusinessManager ?? form.previousBusinessManager;
  if (!snapshot) {
    throw new Error("Cannot apply NoBusinessManager: company has no current business manager");
  }
  return {
    type: DecisionType.noBusinessManager,
    previousBusinessManager: snapshot,
  };
}

export const noBusinessManagerHandler: DecisionTypeHandler<
  DecisionType.noBusinessManager,
  NoBusinessManager,
  NoBusinessManagerForm
> = {
  type: DecisionType.noBusinessManager,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
